/**
 * 错误上报：全局监听（window error / unhandledrejection / offline）
 * 开关：`/system/basic/conf` → `is_enabled`（1 开 / 0 关）
 */

import errorHandler from './errorHandler.js'
import errorConfig from './errorConfig.js'
import { readErrorReportEnabledFromConfObject } from './enabledFromConf.js'

class ErrorLogger {
  constructor () {
    this.isInitialized = false
  }

  /**
   * 公共配置更新后调用（store common/getSystemConf）
   * @param {object} [conf]
   */
  onSystemConfUpdated (conf) {
    errorConfig.invalidateEnabledCache()
    const enabled = readErrorReportEnabledFromConfObject(conf)
    if (enabled === false) return
    this.init().catch(() => {})
  }

  async init () {
    if (this.isInitialized) return
    try {
      errorConfig.invalidateEnabledCache()
      const enabled = await errorConfig.isErrorReportEnabled()
      if (!enabled) return
      await errorHandler.init()
      this.setupGlobalErrorHandlers()
      this.isInitialized = true
    } catch (e) {
      console.warn('[error-report] logger init failed', e)
    }
  }

  setupGlobalErrorHandlers () {
    if (typeof window === 'undefined') return

    window.addEventListener('error', (event) => {
      errorHandler.handleJSError(
        event.error || new Error(event.message),
        event.filename,
        event.lineno,
        event.colno
      )
    })

    window.addEventListener('unhandledrejection', (event) => {
      errorHandler.handlePromiseError(event.reason)
    })

    window.addEventListener('offline', () => {
      errorHandler.handleNetworkError(new Error('network offline'), {
        networkType: 'offline',
      })
    })
  }

  reportApiError (url, error, requestInfo) {
    return errorHandler.handleApiError(url, error, requestInfo)
  }

  reportBusinessError (businessType, error, customData) {
    return errorHandler.handleBusinessError(businessType, error, customData)
  }

  reportError (type, message, additionalInfo) {
    return errorHandler.manualReportError(type, message, additionalInfo)
  }

  reportManual (type, message, additionalInfo) {
    return this.reportError(type, message, additionalInfo)
  }

  getStats () {
    return errorHandler.getErrorStats()
  }

  clearRecords () {
    errorHandler.clearErrorRecords()
  }
}

export default new ErrorLogger()
